const apiUrl = process.env.REACT_APP_API_URL;
const apiUrlV2 = process.env.REACT_APP_API_URL_V2;
const apiKey = process.env.REACT_APP_API_KEY;

async function fetchApiData(apiVersion: 'v1' | 'v2' = 'v1', path: string, method: 'GET' | 'POST' | 'PUT' | 'DELETE' = 'GET') {
    const baseUrl = apiVersion === 'v2' ? apiUrlV2 : apiUrl;
    if (!baseUrl) {
        throw new Error(`Missing REACT_APP_API_URL_${apiVersion.toUpperCase()}`);
    }

    const response = await fetch(`${baseUrl}${path}`, {
        method,
        headers: {
            Authorization: `${apiKey}`,
        },
    });

    if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`Request failed ${response.status}: ${errorText}`);
    }

    return response.json();
}

export async function fetchLaporData() {
    return fetchApiData('v1', '/lapor');
}

export async function fetchBeritaData() {
    return fetchApiData('v1', '/berita');
}

export async function fetchAppsMobile() {
    return fetchApiData('v1', '/apps/mobile', 'POST');
}

export async function fetchPersonalData(nik: string = "") {
    // return fetchApiData('v2', '/karyawan/' + (localStorage.getItem('userNik') || ''));
    return fetchApiData('v2', '/karyawan/' + nik);
}

export async function fetchDokumenData(id: string = "") {
    return fetchApiData('v2', '/dokumen/' + id);
}